<template>
  <div>
    <v-container fluid class="py-6 px-">
      <report-chart
          v-show="getIsShowGraph"
          report-period="Custom"
          :totals="chart.totals"
          :drillDownId="getAppliedSettings && getAppliedSettings.drillDowns ? getAppliedSettings.drillDowns[0].toLowerCase()+'s' : 'offers'"
          :isDataFetched="chart.isDataFetched"
          :isCompared="chart.isCompared"
      />
    </v-container>
    <new-tab-v2
            @goDown="addTab"
            @updateTab="updateTab"
            :is-active="true"
            @updateTotals="chart.totals = $event"
            @isChartDataFetched="chart.isDataFetched = $event"
            @isCompared="chart.isCompared = $event"
            :additionalColumns="additionalColumns"
            :isShowBlacklisted="isShowBlacklisted"
    />
  </div>
</template>

<script>
import ReportChart from '../ReportChart';
import { mapState, mapGetters } from "vuex";

export default {
  props: {
    params: Object,
    additionalColumns: Array,
    name: String,
    isShowBlacklisted: Boolean
  },
  components: {
    ReportChart
  },
  data: vm=>({
    activeTab: 0,
    table: {
      drillDowns: [
        {type: 'offer_id', name: 'Offer', icon: 'mdi-offer'},
        {type: 'program_id', name: 'Program', icon: 'mdi-open-in-app'},
        {type: 'campaign_id', name: 'Campaign', icon: 'mdi-bullhorn-outline'},
        {type: 'sub_campaign', name: 'Sub campaign', icon: 'mdi-bullhorn'},
        {type: 'geo', name: 'Geo', icon: 'mdi-earth'},
        {type: 'day', name: 'Day', icon: 'mdi-calendar-today'},
        {type: 'hour', name: 'Hour', icon: 'mdi-hours-24'},
        {type: 'isp', name: 'ISP', icon: 'mdi-spider-web'},
        {type: 'affiliate_id', name: 'Affiliate', icon: 'mdi-account'},
        {type: 'advertiser_id', name: 'Advertiser', icon: 'mdi-briefcase-account'},
        {type: 'os', name: 'Os', icon: 'mdi-microsoft-windows-classic'},
        {type: 'affiliate_manager_id', name: 'AM', icon: 'mdi-account-tie'},
        {type: 'advertiser_manager_id', name: 'BD!', icon: 'mdi-briefcase-account'},
        {type: 'device', name: 'Device', icon: 'mdi-cellphone-link'},
        {type: 'vertical_name', name: 'vertical_name', icon: 'mdi-align-vertical-bottom'},
        {type: 'referer', value: 'referer', name: 'referer', icon: 'mdi-arrow-expand-right'},
        {type: 'tier', value: 'tier', name: 'Tier', icon: 'mdi-medal'},
        {type: 'highest_tier', value: 'highest_tier', name: 'Highest Tier', icon: 'mdi-medal-outline'},
        {type: 'custom', value: 'custom', name: 'Custom', icon: 'mdi-tune'},
        {type: 'img', value: 'img', name: 'img', icon: 'mdi-tune'},
        {type: 'kw', value: 'kw', name: 'kw', icon: 'mdi-tune'},
        {type: 'cid', value: 'cid', name: 'cid', icon: 'mdi-import'},
        {type: 'lid', value: 'lid', name: 'lid', icon: 'mdi-export'},
      ],
    },
    innerTabs: [],
    innerTabsName: [],
    interval: {},
    value: 0,
    chart: {
      isCompared: false,
      isDataFetched: false,
      totals: {},
      reportPeriod: 'last7days',
      dates: [],
      profile: {
        timezone: [],
      },
      reportPeriodItems: [
        { text: 'Last 7 Days', value: 'last7days' },
        { text: 'Last 30 Days', value: 'last30days' },
        { text: 'This Month', value: 'thisMonth' },
        { text: 'Last Month', value: 'lastMonth' },
        { text: 'Custom Period', value: 'custom' },
      ],
    },
  }),

  created() {
    const savedTabs = JSON.parse(localStorage.getItem(`reports_${this.params.value}`)) || null;
    if (savedTabs && savedTabs.innerTabs && savedTabs.innerTabsName) {
      this.innerTabs = savedTabs.innerTabs;
      this.innerTabsName = savedTabs.innerTabsName;
    } else {
      this.innerTabs.push(this.params)
      this.innerTabsName.push([{name: this.name}]);
    }
    this.saveReports()
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('settings', ['getIsShowGraph', 'getAppliedSettings'])
  },
  watch: {
    activeTab() {}
  },
  methods: {
    updateDates() {
      (this.$refs.menu).save(this.dates);
      this.reportDates = this.dates;
    },
    saveReports() {
      localStorage.setItem(
          `reports_${this.params.value}`,
          JSON.stringify({
            innerTabs: this.innerTabs,
            innerTabsName: this.innerTabsName
          })
      );
    },
    getTabIcon(type) {
      return this.table.drillDowns.find(dd => dd.type === type).icon
    },
    addTab(tab, options) {
      // todo fix tab keys
      // const tabIndex = -1;
      const tabIndex = this.innerTabs.findIndex(t => t.key === tab.key);
      if (tabIndex >= 0) {
        this.activeTab = tabIndex;
      } else {
        this.innerTabs.push({
          key: tab.key,
          id: tab.id,
          value: tab.value,
          name: tab.name,
          type: tab.type,
          entity: tab.entity,
          breadCrumbs: tab.breadCrumbs || [],
          options
        })
        const names = [];
        for(let i = 0; i < tab.breadCrumbs.length; i++) {
          names.push({type: tab.breadCrumbs[i].field, name: tab.breadCrumbs[i].name})
        }
        this.innerTabsName.push(names)
        this.saveReports();
      }
    },
    updateTab(tabKey, options) {
      for(let i = 0; i < this.innerTabs.length; i++) {
        if(this.innerTabs[i].key === tabKey) {
          this.innerTabs[i].options = options;
          break;
        }
      }
      this.saveReports()
    },
    removeTab(tab, index) {
      this.innerTabs.splice(index, 1)
      this.innerTabsName.splice(index, 1)
      this.saveReports()
    },
  },
}
</script>

<style lang="sass">
.theme--light.v-tabs-items
  background-color: transparent !important
/*tabs*/
.reports_affiliates.theme--light.v-tabs>.v-tabs-bar
  height: 38px
  width: fit-content
.reports_affiliates.theme--light.v-tabs>.v-tabs-bar .v-tab
  text-transform: capitalize
  font-size: 0.7rem
  font-weight: 600
  background-color: rgba(58, 56, 82, 0.8)
  border-radius: 4px 4px 0 0
  margin-right: 5px
  color: #FFFFFF !important
.reports_affiliates.theme--light.v-tabs>.v-tabs-bar .v-tab--active
  background-color: #3A3852
.theme--light.v-tabs .v-tab--active:before, .theme--light.v-tabs .v-tab--active:hover:before, .theme--light.v-tabs .v-tab:focus:before
  background-color: #3A3852
.time_period_wrap
  background: #3A3852
  .col-12
    padding-top: 8px
    padding-bottom: 8px
  .v-text-field.v-text-field--solo .v-input__control
    width: 135px !important
    min-height: 32px !important
  .time_period_title
    color: #FFFFFF
    font-size: 14px
    font-weight: 700
    letter-spacing: 0.2px
    padding-right: 10px

  /*datepicker*/
  .datepicker_title
    line-height: 90px
    color: #FFFFFF
    font-size: 14px
    font-weight: 700
    letter-spacing: 0.2px
    padding-right: 10px
  .theme--light.v-icon
    color: #FFFFFF
  .theme--light.v-input input
    color: #FFFFFF
  .theme--light.v-text-field>.v-input__control>.v-input__slot:before
    border-color: #FFFFFF !important

/*table*/
.v-data-table__wrapper
/*min-height: 500px*/
.updateData
  font-size: 14px
  font-style: italic
  color: #ACC3CF
  position: absolute
  bottom: 5px
  left: 450px

.co-tab-title
  text-align: left
  overflow: hidden
  white-space: nowrap

</style>
